import { Modal } from "@mui/material";
import { useTranslation } from "react-i18next";
import useBreakPoinst from "@hooks/useBreakPoinst";
import {
  ModalBox,
  Divider,
  ActionContainer,
  StyledButton,
  CloseButtonContainer,
  ContentWrapper,
  SuccessBox,
  SuccessTitle,
  SuccessDescription,
  StyledSuccessIcon,
} from "./styles/AirbnLinkSuccess";

import CloseMenu from "../../../../assets/svg/closeMenu.svg?react";
import UnBlockingSuccess from "../../../assets/svg/UnBlockingSuccess.svg?react";

interface ConnectAirbnbModalProps {
  open: boolean;
  onClose: () => void;
  handleNextModal?: () => void;
}

const AirbnLinkSuccess = ({
  open,
  onClose,
  handleNextModal,
}: ConnectAirbnbModalProps) => {
  const { isPhone } = useBreakPoinst();
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="connect-airbnb-modal"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <ModalBox $isPhone={isPhone}>
        <CloseButtonContainer onClick={onClose}>
          <CloseMenu />
        </CloseButtonContainer>

        <ContentWrapper $isPhone={isPhone}>
          <SuccessBox>
            <StyledSuccessIcon />
            <SuccessTitle>تم ربط عقاراتك بنجاح! 🎉</SuccessTitle>
            <SuccessDescription>
              أصبحت عقاراتك على Airbnb جاهزة للإدارة من خلال مسؤول.
            </SuccessDescription>
          </SuccessBox>
        </ContentWrapper>

        <Divider />

        <ActionContainer $isPhone={isPhone}>
          <StyledButton
            $TextColor="#5B3FFF"
            $isPhone={isPhone}
            $BgColor="white"
            $width="85px"
            onClick={onClose}
          >
            {t("onBoardingJourny.skip")}
          </StyledButton>
        </ActionContainer>
      </ModalBox>
    </Modal>
  );
};

export default AirbnLinkSuccess;
